var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { ODIcon } from '../../icons';
import { ODInputGuideText } from './ODInputGuideText';
var ODPrependIcon = function (props) {
    var prependIcon = props.prependIcon;
    return (React.createElement("div", { className: "pl-3 pointer-events-none" },
        React.createElement(ODIcon, { icon: prependIcon })));
};
var TextLength = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-left: auto;\n  margin-right: 5px;\n  font-size: 0.85rem;\n  color: #73818f;\n"], ["\n  margin-left: auto;\n  margin-right: 5px;\n  font-size: 0.85rem;\n  color: #73818f;\n"])));
export var ODInput = function (props) {
    var id = props.id, placeholder = props.placeholder, value = props.value, onChange = props.onChange, prependIcon = props.prependIcon, guideText = props.guideText, cnProps = __rest(props, ["id", "placeholder", "value", "onChange", "prependIcon", "guideText"]);
    var cn = classNames('od-input', cnProps, { pl7: !!prependIcon });
    var cnWrapper = classNames('od-input-wrapper', {
        success: cnProps.success,
        error: cnProps.error,
    });
    return (React.createElement("div", { className: "px-2 py-1", style: { display: 'flex', flexDirection: 'column' } },
        React.createElement("div", { className: cnWrapper },
            prependIcon && React.createElement(ODPrependIcon, { prependIcon: prependIcon }),
            React.createElement("input", { id: id, disabled: cnProps.disabled, className: cn, placeholder: placeholder, value: value, onChange: onChange })),
        React.createElement(TextLength, null,
            value ? value.length : 0,
            "/200"),
        React.createElement(ODInputGuideText, { text: guideText, error: cnProps.error })));
};
var templateObject_1;
//# sourceMappingURL=ODInput.js.map